import { useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { useResize } from 'reactUtils/hooks/use-resize'

import { Header } from 'lmcv/components/Header'
import { Navigation } from 'lmcv/components/Navigation'

function HeaderContainer ({ history }) {
  const data = useSelector(state => state.user)
  const [isMobile] = useResize()

  /**
   * If isDesktop check routes to render header
   */
  const isDesktopOnHome = !isMobile && history.location.pathname !== '/'

  if (!isDesktopOnHome) {
    return (
      <Header user={data.get.payload}>
        <Navigation history={history} status={data.get.payload.status} />
      </Header>
    )
  }

  return null
}

export default withRouter(HeaderContainer)
